import { render, staticRenderFns } from "./labarugi.vue?vue&type=template&id=410cfc9e&"
import script from "./labarugi.vue?vue&type=script&lang=js&"
export * from "./labarugi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports